module.exports = __webpack_public_path__ + "hyperion-v2-static/img/baselayer-satellite-btn-60x60.6a73ff0b.png";